import { domain } from 'modules/data';

export const compareByCodeAndIsCrypto = (currencyA: domain.Currency, currencyB: domain.Currency) =>
    Number(currencyA.isCrypto) - Number(currencyB.isCrypto) ||
    currencyA.code.toLowerCase().localeCompare(currencyB.code.toLowerCase());
